import { HelmetDexteel } from "@dexteel/mesf-core";
import { Grid } from "@mui/material";
import * as React from "react";
import { ConfigurationDelayComponent } from "./components/DelayConfiguration/ConfigurationDelayComponent";
type Props = {
	delayAreaAssetId?: number;
	delayAreaAssetName?: string;
};
export const CatalogDelayPage = ({
	delayAreaAssetId,
	delayAreaAssetName,
}: Props) => {
	return (
		<>
			<HelmetDexteel
				title={`${delayAreaAssetName || "Delay"} Codes - Configurations`}
			/>
			<Grid container justifyContent="center" alignItems="center">
				<ConfigurationDelayComponent
					delayAreaAssetId={delayAreaAssetId}
					delayAreaAssetName={delayAreaAssetName}
				/>
			</Grid>
		</>
	);
};
